module.exports = __webpack_public_path__ + "onboarding3.png";